import {Breadcrumb} from '@ui/breadcrumbs/breadcrumb';
import {BreadcrumbItem} from '@ui/breadcrumbs/breadcrumb-item';
import {Trans} from '@ui/i18n/trans';
import {useNavigate} from '../../ui/navigation/use-navigate';
import {BillingPlanPanel} from './billing-plan-panel';
import {Fragment} from 'react';
import {useProducts} from '../pricing-table/use-products';
import {Link} from 'react-router-dom';
import {Button} from '@ui/buttons/button';
import {FormattedPrice} from '../formatted-price';
import {invalidateBillingUserQuery, useBillingUser} from './use-billing-user';
import {FormattedDate} from '@ui/i18n/formatted-date';
import { Footer } from '../../ui/footer/footer';
import { StaticPageTitle } from '../../seo/static-page-title';
import { Navbar } from '../../ui/navigation/navbar/navbar';

const previousUrl = '/billing/change-plan';

export function ConfirmPlanRenewalPage() {
  const navigate = useNavigate();
  const query = useProducts();
  const {subscription} = useBillingUser();

  const product = subscription?.product;
  const price = subscription?.price;
  const productId = product?.id;
  const priceId = price?.id;
  
  if (!query.data) {
    return null;
  }

  if (!subscription || !product || !price) {
    navigate(previousUrl);
    return null;
  }

  if (!query.data || !subscription || !product || !price) {
    return null;
  }

  const now = new Date();
  const endDateObj = new Date(subscription.ends_at);

  const diffTime = endDateObj.getTime() - now.getTime();
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // ⛔ BLOCK if more than 3 days
  if (daysLeft > 3) {
    navigate(previousUrl);
    return null;
  }

  const endDate = (
    <span className="whitespace-nowrap">
      <FormattedDate date={subscription.ends_at} preset="long" />;
    </span>
  );


  return (
    <Fragment>
      <div className="flex min-h-screen flex-col bg-alt"
        style={{ backgroundImage: "url('/images/LandingImg/ctamask.png')" }}
      >
        <StaticPageTitle>
          <Trans message="Renew Plan" />
        </StaticPageTitle>

        <Navbar
          color="transparent"
          className="fixed top-0 sticky z-50 w-full border-none shadow-lg"
          menuPosition="billing-page"
        />

        <div className="container mx-auto my-24 flex-auto px-14">
          <Breadcrumb>
            <BreadcrumbItem isLink onSelected={() => navigate(previousUrl)}>
              <Trans message="Billing" />
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Trans message="Renew" />
            </BreadcrumbItem>
          </Breadcrumb>

          <h1 className="my-32 text-3xl font-bold md:my-64">
            <Trans message="Renew your plan" />
          </h1>

          <BillingPlanPanel title={<Trans message="Current plan" />}>
            <div className="max-w-[464px]">
              <div className="text-xl font-bold">{product.name}</div>
              <FormattedPrice price={price} className="text-lg" />

              <div className="mb-48 mt-12 border-b pb-24 text-base">
                <Trans
                  message="This plan will renew on :date"
                  values={{date: endDate}}
                />
              </div>

              <div className="mb-16 text-sm text-green-600">
                {daysLeft} day(s) left. You can renew your plan.
              </div>

              <Button
                variant="flat"
                color="primary"
                size="md"
                className="mb-16 w-full"
                onClick={() => {
                  navigate(`/checkout/${productId}/${priceId}`);
                }}
              >
                <Trans message="Renew plan" />
              </Button>

              <Button
                variant="outline"
                className="w-full"
                to={previousUrl}
                elementType={Link}
              >
                <Trans message="Go back" />
              </Button>
            </div>
          </BillingPlanPanel>
        </div>
        
        <Footer className="container mx-auto px-24" />
      </div>
    </Fragment>

  );
}
